import React from 'react';
import ConsentForm, { ConsentFormProps } from '../components/ConsentForm';
import Header from '../components/Header';

export interface ServicetjekSamtykkeProps {
    currentBlock: ConsentFormProps,
	erMedlem: string
	email: string
	samtykke: string
	telefon: string,
	samtykkeLabel: string
}

const ServicetjekSamtykke = ({ currentBlock: { ...props }, email, samtykke, telefon, samtykkeLabel }:ServicetjekSamtykkeProps) => {
	return (
		<>
			<Header title={ 'Samtykke' } baseUrl={ props.baseUrl } />
			<ConsentForm userInfo={ { email, samtykke, telefon, samtykkeLabel } } { ...props } />
		</>
	);
};

export default ServicetjekSamtykke;